<template>
  <base-layout>
    <div class="game" v-if="players.length > 0">
      <div v-if="!startedTurn">
        <dx-turn :player="mediator" @click="startTurn" />
      </div>
      <div v-if="startedTurn">
        <div class="text-center" v-if="loading">
          <dx-spinner :active="true" />
        </div>
        <div class="container-fluid" v-if="!loading">
          <dx-card-header
            :id="card.id"
            :answer="card.answer"
            :item-type="card.card_type.name"
            :level="card.card_level.name"
            />
          <dx-card-slider-tips
            :tips="tips"
            :disableds="playedTips"
            @change="onChangeTip"
            />
          <dx-card-actions
            @hit="onHit"
            @missed="onMissed"
            @rollback="onRollback"
            :disabled-actions="currentPlayedTip"
            />
          <dx-card-players
            :currentPlayer="currentPlayerID"
            :mediator="mediator"
            :players="players"
            />
          <dx-card-vote
            :itemId="card.id"
            :user="card.user"
            @vote="onVote"
            />
        </div>
      </div>
    </div>
  </base-layout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { BaseLayout } from '../layouts'
import {
  DxCardHeader,
  DxCardSliderTips,
  DxCardActions,
  DxCardPlayers,
  DxCardVote,
  DxButton,
  DxSpinner,
  DxTurn
} from '../components'
export default {
  name: 'game',
  components: {
    BaseLayout,
    DxCardHeader,
    DxCardSliderTips,
    DxCardActions,
    DxCardPlayers,
    DxCardVote,
    DxButton,
    DxSpinner,
    DxTurn
  },
  data () {
    return {
      loading: false,
      vote: null
    }
  },
  methods: {
    ...mapActions([
      'addPoints',
      'loadCard',
      'hit',
      'missed',
      'rollbackTurn',
      'setTip',
      'beginTurn',
      'cardVote'
    ]),
    startTurn () {
      this.loading = true
      this.beginTurn()
      this.loadCard().then(() => {
        this.loading = false
      }).catch((error) => {
        console.log(error)
        this.loading = false
      })
    },
    onHit () {
      this.onCardVote()
      this.hit()
    },
    onMissed () {
      this.onCardVote()
      this.missed()
    },
    onRollback () {
      this.rollbackTurn()
    },
    onChangeTip (tip) {
      this.setTip(tip)
    },
    onVote (liked) {
      this.vote = liked ? 'up' : 'down'
    },
    onCardVote () {
      if (this.vote) {
        this.cardVote(this.vote).then(() => {
          this.vote = null
        }).catch(() => {
          this.vote = null
        })
      }
    }
  },
  computed: {
    ...mapGetters({
      players: 'getPlayers',
      mediator: 'getMediator',
      currentPlayerID: 'getCurrentPlayerID',
      card: 'getCard',
      playedTips: 'getPlayedTips',
      tip: 'getTip',
      startedTurn: 'getStartedTurn',
      finished: 'getFinished'
    }),
    currentPlayedTip () {
      return this.playedTips.indexOf(this.tip) > -1
    },
    tips () {
      return this.card.card_tips.map(i => i.tip)
    }
  },
  watch: {
    finished () {
      this.$router.push({ name: 'endGame' })
    }
  },
  created () {
    if (this.players.length === 0) {
      this.$router.push({ name: 'home' })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Game.vue